








































































import Vue from 'vue';
import _ from 'lodash';

import Requester from '../../requester';

import { Internacao } from '../../../../back/src/entity/Internacao';
import { egbStrings } from '../../utils/constants';
import { Egb } from '../../../../back/src/types';

import IfEmptyTextPrintNA from '../IfEmptyTextPrintNA.vue';

export default Vue.extend({
  name: 'TheInternacoesTabelaFinalizadas',
  components: {
    IfEmptyTextPrintNA,
  },
  props: {
    lastSearch: {
      type: String,
      default: '',
    },
    search: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: {
        table: true,
      },
      options: {
        itemsPerPage: 30,
        sortBy: ['data_alta'],
        sortDesc: [true],
      },
      totalRegistros: 0,
      internacoes: [] as Internacao[],
      headers: [
        {
          value: 'data_alta',
          text: 'Data de alta',
          sortable: false,
        },
        {
          value: 'paciente.nome',
          text: 'Paciente',
          sortable: false,
        },
        {
          value: 'local',
          text: 'Local',
          sortable: false,
        },
        {
          value: 'quarto',
          text: 'Quarto',
          sortable: false,
        },
        {
          value: 'motivo',
          text: 'Motivo',
          sortable: false,
        },
        {
          value: 'egb',
          text: 'EGB',
          sortable: false,
        },
        {
          value: 'datetime_internacao',
          text: 'Data da internação',
          sortable: false,
        },
        {
          value: 'actions',
          text: 'Ações ',
          sortable: false,
          width: 0,
          align: 'center',
        },
      ],
    };
  },
  computed: {
    numPaginas() {
      if (this.totalRegistros === 0) {
        return 1;
      }
      return Math.ceil(this.totalRegistros / this.options.itemsPerPage);
    },
  },
  mounted() {
    // this.carregaNovaPagina(this.search);
  },
  methods: {
    egbStrings(egb: Egb) {
      return _.get(egbStrings, egb, null);
    },
    async carregaNovaPagina(search) {
      this.loading.table = true;
      this.internacoes = [];
      // options tipo
      const queryObj: any = {
        pagina: this.options.page,
        itens_por_pagina: this.options.itemsPerPage,
      };
      if (this.options.sortBy.length > 0) {
        [queryObj.sortBy] = this.options.sortBy;
        [queryObj.sortDesc] = this.options.sortDesc;
      }
      try {
        const response = await Requester.internacao.buscaInternacoesFinalizadas(queryObj);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.internacoes = response.data.registros;
          this.totalRegistros = response.data.total_registros;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.table = false;
      }
    },
  },
  watch: {
    options: {
      handler() {
        this.carregaNovaPagina(this.search);
      },
      deep: true,
    },
  },
});
